/**
 * Snapshot pages constants
 */

// Pagination
export const PAGE_SIZE = 10

// Bytes conversion constants
export const BYTES_PER_GB = 1024 * 1024 * 1024
